/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  NotificationPreferenceResponse,
  UpdateNotificationPreferenceRequest,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    NotificationPreferenceResponseFromJSON,
    NotificationPreferenceResponseToJSON,
    UpdateNotificationPreferenceRequestFromJSON,
    UpdateNotificationPreferenceRequestToJSON,
} from '../models/index';

export interface FindNotificationPreferencesRequest {
    instituteId: string;
    personId: string;
}

export interface UpdateNotificationPreferenceOperationRequest {
    notificationPreferenceId: string;
    instituteId: string;
    personId: string;
    updateNotificationPreferenceRequest: UpdateNotificationPreferenceRequest;
}

/**
 * 
 */
export class NotificationPreferenceApi extends runtime.BaseAPI {

    /**
     * Find notification preferences
     */
    async findNotificationPreferencesRaw(requestParameters: FindNotificationPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NotificationPreferenceResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling findNotificationPreferences().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling findNotificationPreferences().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instituteId'] != null) {
            queryParameters['institute_id'] = requestParameters['instituteId'];
        }

        if (requestParameters['personId'] != null) {
            queryParameters['person_id'] = requestParameters['personId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notification-preferences`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NotificationPreferenceResponseFromJSON));
    }

    /**
     * Find notification preferences
     */
    async findNotificationPreferences(requestParameters: FindNotificationPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NotificationPreferenceResponse>> {
        const response = await this.findNotificationPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update notification preference
     */
    async updateNotificationPreferenceRaw(requestParameters: UpdateNotificationPreferenceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationPreferenceResponse>> {
        if (requestParameters['notificationPreferenceId'] == null) {
            throw new runtime.RequiredError(
                'notificationPreferenceId',
                'Required parameter "notificationPreferenceId" was null or undefined when calling updateNotificationPreference().'
            );
        }

        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateNotificationPreference().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updateNotificationPreference().'
            );
        }

        if (requestParameters['updateNotificationPreferenceRequest'] == null) {
            throw new runtime.RequiredError(
                'updateNotificationPreferenceRequest',
                'Required parameter "updateNotificationPreferenceRequest" was null or undefined when calling updateNotificationPreference().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instituteId'] != null) {
            queryParameters['institute_id'] = requestParameters['instituteId'];
        }

        if (requestParameters['personId'] != null) {
            queryParameters['person_id'] = requestParameters['personId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notification-preferences/{notification_preference_id}`.replace(`{${"notification_preference_id"}}`, encodeURIComponent(String(requestParameters['notificationPreferenceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateNotificationPreferenceRequestToJSON(requestParameters['updateNotificationPreferenceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationPreferenceResponseFromJSON(jsonValue));
    }

    /**
     * Update notification preference
     */
    async updateNotificationPreference(requestParameters: UpdateNotificationPreferenceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationPreferenceResponse> {
        const response = await this.updateNotificationPreferenceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
